export default __webpack_public_path__ + "static/media/desktopBgAtRetina.8d656e61.png";